import { render, staticRenderFns } from "./complaintItem.vue?vue&type=template&id=04b8f026&"
import script from "./complaintItem.vue?vue&type=script&lang=js&"
export * from "./complaintItem.vue?vue&type=script&lang=js&"
import style0 from "./complaintItem.vue?vue&type=style&index=0&id=04b8f026&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports